import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

/** Mirrors the review page: header card, answers on the left, feedback panel on the right. */
export const ReviewSubmissionSkeleton: FC = () => (
  <Box>
    <Skeleton variant="text" width={140} sx={{ mb: 1.5 }} />
    <Skeleton variant="rectangular" height={80} sx={{ borderRadius: '12px', mb: 2.5 }} />
    <Box
      sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) minmax(360px, 440px)' }, gap: 2.5 }}
    >
      <Skeleton variant="rectangular" height={360} sx={{ borderRadius: '12px' }} />
      <Skeleton variant="rectangular" height={360} sx={{ borderRadius: '12px' }} />
    </Box>
  </Box>
);
